module.exports = __webpack_public_path__ + "static/media/BG.00dca76a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/BG.svg
// module id = 203
// module chunks = 0